/**
 * Lets any page open the Help Center without owning it. The panel lives in the
 * app shell (`shell/Layout.tsx`), which listens for this window event.
 *
 * `openHelpForPage` finds the help article filed under a page key (for example
 * `cockpit:it/service-desk`) and opens the panel on it. When the page has no
 * article yet, or the lookup fails, the panel opens on its home view instead so
 * the click always does something useful.
 */

import type { HelpCenterView } from '@ampersandbrands/ui';
import { cockpitServiceDeskClient } from './serviceDeskClient';

export const OPEN_HELP_EVENT = 'cockpit:open-help';

export type OpenHelpDetail = { view?: HelpCenterView };

export function openHelp(view?: HelpCenterView): void {
  window.dispatchEvent(new CustomEvent<OpenHelpDetail>(OPEN_HELP_EVENT, { detail: { view } }));
}

export async function openHelpForPage(pageKey: string): Promise<void> {
  try {
    const mapped = await cockpitServiceDeskClient.getCategoryForPage(pageKey);
    const categoryId = mapped?.subcategory?.id ?? mapped?.category?.id;
    if (categoryId) {
      const articles = await cockpitServiceDeskClient.searchArticles('', categoryId);
      const first = articles[0];
      if (first) {
        openHelp({ article: first.id });
        return;
      }
    }
  } catch {
    // Fall through to the home view.
  }
  openHelp();
}
